type PromiseTask<T> = () => Promise<T>

class PromiseQueue {
  private concurrency: number
  private queue: Array<() => void> = []
  private activeCount = 0

  constructor(concurrency: number) {
    if (concurrency < 1) {
      throw new Error('Concurrency must be at least 1')
    }
    this.concurrency = concurrency
  }

  add<T>(fn: PromiseTask<T>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      const task = async () => {
        this.activeCount++
        try {
          const result = await fn()
          resolve(result)
        }
        catch (err) {
          reject(err)
        }
        finally {
          this.activeCount--
          this.next()
        }
      }

      this.queue.push(task)
      this.next()
    })
  }

  private next(): void {
    if (this.activeCount >= this.concurrency || this.queue.length === 0) {
      return
    }

    const task = this.queue.shift()
    if (task) { task() }
  }
}

export default new PromiseQueue(100)
